import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    scholarshipList: [],
    totalRecords: 0,
    scholarshipDetails: {},
    message: null,
    createEditScholarshipLoading: false,
    createEditScholarshipSuccess: {},
    createEditScholarshipError: '',
}

export const scholarshipSlice = createSlice({
    name: 'scholarship',
    initialState,
    reducers: {
        getScholarshipList: (state, action) => {
            state.scholarshipList = action.payload.data?.data;
            state.totalRecords = action.payload.data?.totalRecord;
            state.message = action.payload.message;
        },
        getScholarshipDetails: (state, action) => {
            state.scholarshipDetails = action.payload
        },
        setCreateEditScholarshipLoading: (state) => {
            state.createEditScholarshipLoading = true;
            state.createEditScholarshipSuccess = {};
            state.createEditScholarshipError = '';
        },
        setCreateEditScholarshipSuccess: (state, action) => {
            state.createEditScholarshipLoading = false;
            state.createEditScholarshipSuccess = action.payload;
            state.createEditScholarshipError = '';
        },
        setCreateEditScholarshipError: (state, action) => {
            state.createEditScholarshipLoading = false;
            state.createEditScholarshipSuccess = {};
            state.createEditScholarshipError = action.payload;
        },
        resetScholarshipData: (state, action) => {
            state.createEditScholarshipLoading = false;
            state.createEditScholarshipSuccess = {};
            state.createEditScholarshipError = '';
        },
    },
})

// Action creators are generated for each case reducer function
export const { getScholarshipList, getScholarshipDetails, setCreateEditScholarshipLoading, setCreateEditScholarshipSuccess, setCreateEditScholarshipError, resetScholarshipData } = scholarshipSlice.actions

export default scholarshipSlice.reducer;